import { SeeqNames } from 'generated-seeqnames/app.constants.seeqnames';

export const getLockingChannel = (workbookId: string) => [SeeqNames.Channels.LockingChannel, workbookId];
